module.exports = __webpack_public_path__ + "static/media/slide_8.6be38cb4.jpg";